module.exports = __webpack_public_path__ + "img/4.0f4b7e08.jpg";